import * as React from "react";
import BasketExpressCheckout from "./BasketExpressCheckout";
import BasketContext from "../services/BasketContext";
import BasketService from "../services/BasketService";
import useNotification from "./notification/useNotification";
import Placeholder from "./Placeholder";
import EmptyBasket from "./EmptyBasket";
import { IBasket } from "../models/IBasket.model";
import NotificationType from "./notification/NotificationType";
import WishlistService from "../../../wishlistsrc/src/services/WishlistService";
import WishlistContext from "../../../wishlistsrc/src/services/WishlistContext";
import { IWishlist } from "../../../wishlistsrc/src/models/IWishlist.model";
import Logger from "../../../gulp/scripts/typescript/modules/Logger";
import Ecommerce from "../../../gulp/scripts/typescript/modules/ecommerce";

// Express-checkout A/B test variant of App.tsx - identical except it renders
// BasketExpressCheckout instead of Basket. See BasketExpressCheckout.tsx/
// OrderSummaryExpressCheckout.tsx.
function AppExpressCheckout() {
	const [isLoading, setIsLoading] = React.useState(false);
	const [basket, setBasket] = React.useState<IBasket>();
	const [wishlist, setWishlist] = React.useState<IWishlist>();
	const [wishlistItemCount, setWishlistItemCount] = React.useState(0);
	const { addNotification } = useNotification();
	const basketService = new BasketService();
	const wishlistService = new WishlistService();
	const numberOfItemsTheBasketPageIndicatesOnLoad = document && document.querySelector('[data-basket-line-items]') ? parseInt(document.querySelector('[data-basket-line-items]').getAttribute('data-basket-line-items')) : 0;

	React.useEffect(() => {
		getBasket();
		getWishlist();
		if(document) {
			document.addEventListener('atbcloseoverlay', () => {
				getBasket();
				getWishlist();
			});
			document.addEventListener('productViewerClosed', () => {
				getBasket();
				getWishlist();
			});
		}
	}, []);

	React.useEffect(() => {
		setWishlistItemCount(wishlist?.TotalItemQuantity);
	}, [wishlist]);

	function getWishlist() {
		wishlistService.getWishlist()
			.then((data) => {
				setWishlist(data);
				setIsLoading(false);
			})
			.catch(() => {
				setIsLoading(false);
			});
	}

	function getBasket() {
		setIsLoading(true);
		basketService
		.getBasket()
			.then((data) => {
				setBasket(data);
		})
		.catch((error: Error) => {
			addNotification({
				headline: 'An error has occurred trying to retrieve your basket. Please try again.',
				type: NotificationType.error
			});
			Logger.trackException(error, 'Unknown error in get basket endpoint');
		});
	}

	React.useEffect(() => {
		if (document && basket) {
			Ecommerce.updateBasketCounts(basket.TotalItemQuantity.toString());
		}
	}, [basket]);

	if (!basket) {
		return <Placeholder numberOfLineItems={numberOfItemsTheBasketPageIndicatesOnLoad} />;
	}

	return (
		<div className={isLoading ? "c-basket--loading" : ""}>
			<WishlistContext.Provider
				value={{
					wishlist, setWishlist,
				}}>
			<BasketContext.Provider
				value={{
					basket,
					setBasket,
				}}
				>

				{basket?.TotalItemQuantity === 0 ? (
					<EmptyBasket wishlistItemCount={wishlistItemCount} />
				) : (
					<React.Fragment>
						<BasketExpressCheckout />
					</React.Fragment>
				)}
			</BasketContext.Provider>
			</WishlistContext.Provider>
		</div>
	);
}

export default AppExpressCheckout;
